
import {WxConfig} from '../api/common'
import wx from 'weixin-js-sdk'


export const wxConfig = () => {
    WxConfig({
        url: encodeURIComponent(window.location.href.split('#')[0])
    }).then((res) => {
        wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.Data.JSSDK.AppId, // 必填，公众号的唯一标识
            timestamp: res.Data.JSSDK.Timestamp, // 必填，生成签名的时间戳
            nonceStr: res.Data.JSSDK.NonceStr, // 必填，生成签名的随机串
            signature: res.Data.JSSDK.Signature, // 必填，签名
            jsApiList: ['checkJsApi', 'chooseImage', 'previewImage', 'openEnterpriseChat'], // 必填，需要使用的JS接口列表
            fail: function(res){
                console.log('wx.config失败--', res)
            }
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/wxConfig.js